 
import React from 'react';
import { Grid } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import {
  PageTitleAndSubTitle,
  WasteCalculatorCard,
} from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import { Typography } from '@HomaHealth/ui-component-library/lib/_patient-access-components';
import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import { observer } from 'mobx-react';
import accessDashboardConstants from '../../core-utils/messages/AccessDashboardConstants';
import { useNavigate } from 'react-router-dom';
import { useStores } from '../../stores';
import { isCardFeatureAccessible } from '../../core-utils/helper-utils/userAccess';
const useStyles = makeStyles()({
  root: {
    display: 'flex',
    flexDirection: 'column',
    padding: '40px 0px 66px 63px',
  },
  cards: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '32px',
  },
});
const AllReports = observer(() => {
  const messages = accessDashboardConstants;
  const { classes } = useStyles();
  const cardsData = accessDashboardConstants?.ALL_REPORTS_CARDS;
  const navigate = useNavigate();
  const loginPageStore = useStores().loginPageStore;

  // Use States

  // Components
  const AllReportsCards = React.memo(() => {
    return (
      <Grid container style={{ flexDirection: 'column' }}>
        <Grid className={classes.cards}>
          {cardsData?.map((category: any, index: number) => {
            const hasAccess = isCardFeatureAccessible(
              category?.path,
              [
                ...(loginPageStore.userResponse.complianceAssuranceScreens ??
                  []),
                ...(loginPageStore.userResponse.riskManagementScreens ?? []),
              ],
              loginPageStore.userResponse.role.name,
            );
            return (
              <div key={index}>
                <WasteCalculatorCard
                  height="325px"
                  width="358px"
                  title={category?.category}
                  subTitle={category.subTitle}
                  image={category.image}
                  titleFont="16px"
                  showExternalLink={false}
                  imageHeight="193px"
                  showTooltip={true}
                  isNoAccess={!hasAccess}
                  handleNoAccess={() => {
                    window.location.href = 'mailto:sales@homahealth.us';
                  }}
                  handleOnClick={() => {
                    navigate(category?.path);
                  }}
                  truncatedSubTitleLength={140}
                />
              </div>
            );
          })}
        </Grid>
      </Grid>
    );
  });

  // components
  return (
    <div>
      <Grid container className={classes.root}>
        <Grid
          style={{
            marginBottom: '36px',
            width: '1182px',
            position: 'relative',
          }}
        >
          <PageTitleAndSubTitle
            title={
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <Typography
                    fontSize="18px"
                    lineHeight="22px"
                    fontType="semiBold"
                    textColor={patientAccessTheme.palette.text.highemphasis}
                  >
                    {messages.ALL_REPORTS_TITLE}
                  </Typography>
                </div>
              </div>
            }
            subTitle={messages.ALL_REPORTS_SUBTITLE}
            showDownloadButton={false}
            showQueryDataButton={false}
          />
        </Grid>
        <Grid style={{ marginBottom: '38px' }}>
          <AllReportsCards />
        </Grid>
      </Grid>
    </div>
  );
});

export default AllReports;
